<div [ngClass]="['rg', bodyClass]" *ngIf="rows.length > 0">
  <div class="rg-container-body">
    <section class="rg-card" *ngFor="let row of rows; trackBy: trackByEmployee">
      <header class="rg-title">Employee Name: <strong>{{ row.employee_name }}</strong></header>
      <div class="rg-scroll">
        <table class="rg-grid">
          <thead>
            <tr>
              <th class="rg-corner" scope="col">Date</th>
              <th *ngFor="let entry of row.entries; trackBy: trackByEntry" scope="col">{{ entry.date_label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="rg-label" scope="row">Shift</th>
              <td *ngFor="let entry of row.entries; trackBy: trackByEntry" class="rg-value">{{ entry.shift }}</td>
            </tr>
            <tr>
              <th class="rg-label" scope="row">Status</th>
              <td *ngFor="let entry of row.entries; trackBy: trackByEntry" class="rg-value">
                <span *ngIf="statusIsPlain(entry)">--</span>
                <span
                  *ngIf="!statusIsPlain(entry)"
                  class="rg-badge"
                  [ngStyle]="{
                    background: getStatusConfig(entry.status_key)?.bg,
                    color: getStatusConfig(entry.status_key)?.text
                  }"
                >
                  {{ getStatusConfig(entry.status_key)?.label }}
                </span>
              </td>
            </tr>
            <tr>
              <th class="rg-label" scope="row">Location</th>
              <td *ngFor="let entry of row.entries; trackBy: trackByEntry" class="rg-value">{{ entry.location }}</td>
            </tr>
            <tr>
              <th class="rg-label" scope="row">Opening</th>
              <td *ngFor="let entry of row.entries; trackBy: trackByEntry" class="rg-value">
                <ng-container *ngIf="entry.is_editable && !readonly; else openingView">
                  <app-currency-action-input
                    [(ngModel)]="entry.opening_balance"
                    (ngModelChange)="onOpeningChange(entry, $event)"
                    [showAction]="false"
                    [allowNull]="true"
                    [useNumberInput]="true"
                    [minInput]="'1'"
                  />
                  
                </ng-container>
              
                <ng-template #openingView>
                  <span *ngIf="entry.opening_balance !== null; else openingNa">
                    {{ formatCurrency(entry.opening_balance) }}
                  </span>
                  <ng-template #openingNa>--</ng-template>
                </ng-template>
              </td>
            </tr>
            <tr>
              <th class="rg-label" scope="row">Expected</th>
              <td *ngFor="let entry of row.entries; trackBy: trackByEntry" class="rg-value">{{
                formatCurrency(entry.expected_closing)
              }}</td>
            </tr>
            <tr>
              <th class="rg-label" scope="row">Closing</th>
              <td *ngFor="let entry of row.entries; trackBy: trackByEntry" class="rg-value">
                <ng-container *ngIf="entry.is_editable && !readonly; else closingView">
                  <app-currency-action-input
                    [(ngModel)]="entry.closing_balance"
                    (ngModelChange)="onClosingChange(entry, $event)"
                    [showAction]="false"
                    [allowNull]="true"
                    [useNumberInput]="true"
                    [minInput]="'1'"
                  />
                </ng-container>
              
                <ng-template #closingView>
                  <span *ngIf="entry.closing_balance !== null; else closingNa">
                    {{ formatCurrency(entry.closing_balance) }}
                  </span>
                  <ng-template #closingNa>--</ng-template>
                </ng-template>
              </td>
            </tr>
            <tr>
              <th class="rg-label" scope="row">Delta</th>
              <td *ngFor="let entry of row.entries; trackBy: trackByEntry" class="rg-value">
                <app-cash-reconciliation-status-badge
                  [status]="entry.match_status"
                  [delta]="entry.delta ?? 0"
                  [showStatus]="false"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <footer class="rg-actions" *ngIf="!readonly">
        <button type="button" class="rg-cancel" (click)="cancelFor(row)">Cancel</button>
        <button
          type="button"
          class="rg-save"
          [disabled]="isSaving(row.employee_id) || !hasChanges(row)"
          (click)="submitSave(row)"
        >
          {{ isSaving(row.employee_id) ? 'Saving...' : 'Save Changes' }}
        </button>
      </footer>
    </section>
  </div>
</div>
